/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const LoginCodeViaEnum = {
    Code: 'code',
    Link: 'link'
};
/**
 * Check if a given object implements the LoginCode interface.
 */
export function instanceOfLoginCode(value) {
    if (!('grantId' in value) || value['grantId'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    return true;
}
export function LoginCodeFromJSON(json) {
    return LoginCodeFromJSONTyped(json, false);
}
export function LoginCodeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'grantId': json['grant_id'],
        'code': json['code'],
        'via': json['via'] == null ? undefined : json['via'],
    };
}
export function LoginCodeToJSON(json) {
    return LoginCodeToJSONTyped(json, false);
}
export function LoginCodeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'grant_id': value['grantId'],
        'code': value['code'],
        'via': value['via'],
    };
}
